import React from 'react';
import { Input, Button, Col, Form, Modal, message, Menu, Dropdown } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import Amplify from 'aws-amplify';
import { API, graphqlOperation } from 'aws-amplify';
import { Admin } from '../../queries';
class CustomNotification extends React.Component {
  state = {
    active: false,
    active1: false,
    recieverIdValue: this.props.user,
    inputValue: '',
    headingsValue: '',
    testUsers: [
      'ck73jmzv320ku0954aofjgi9t',
      'ck52j4gyacg2y0842dqxc7uet',
      'cjt05k3kj0000aap4fbtp9pay',
      'cjt4n4g5f00f90847auidweic',
    ],
    testUser: { id: 'cjt05k3kj0000aap4fbtp9pay', name: 'نضال نواصرة' },
    testUserValues: [],
    SubMessageValue: '',
    dataIdValue: '',
    url: 'https://khareta.com',
    dataUrlValue: '',
    testUserField: '',
    pushlinks: ['/user_page/edit/', '/search/', '/profile', '/notifications'],
    visible: false,
    types: ['NEW_AD', 'USER_PAGE', 'OTHER'],
    type: 'NEW_AD',
    imageValue: '',
    images: [
      'https://is5-ssl.mzstatic.com/image/thumb/Purple124/v4/78/61/c0/7861c0f4-8700-3064-dadc-d28b76137ec7/source/512x512bb.jpg',
      '',
    ],
    imageUrl:
      'https://is5-ssl.mzstatic.com/image/thumb/Purple124/v4/78/61/c0/7861c0f4-8700-3064-dadc-d28b76137ec7/source/512x512bb.jpg',
  };

  async componentDidMount() {
    const { token } = this.props.props;

    Amplify.configure({
      API: {
        graphql_headers: async () => ({
          Authorization: `Bearer ${token}`,
        }),
      },
    });
    await this.handleUserNames();
  }
  handleMessage(v) {
    this.setState({ inputValue: v.target.value });
  }
  handleHeadings(v) {
    this.setState({ headingsValue: v.target.value });
  }

  handleSubMessage(v) {
    this.setState({ SubMessageValue: v.target.value });
  }
  handleDataId(v) {
    if (this.state.type === 'NEW_AD') {
      this.queryListings(v.target.value);
    }
    this.setState({ dataIdValue: v.target.value });
  }
  handleDataUrl(v) {
    this.setState({ dataUrlValue: v.target.value });
  }

  handleCancel = (e) => {
    this.setState({
      visible: false,
    });
  };
  handleType(v) {
    this.setState({ type: v.target.value });
  }

  queryListings(v) {
    API.graphql(
      graphqlOperation(Admin.Listing.GET_LISTING_IMAGES_AND_URL_AND_S3PREFIX, {
        where: {
          id: v,
        },
      })
    ).then(async (data) => {
      if (data.data.listing !== undefined) {
        const arr = this.state.images;
        const checks =
          data.data.listing.images.find((image) => image.main === true) !==
          undefined;
        if (checks === true) {
          const url = `${process.env.REACT_APP_IMAGES_BASE_URL}/listings/full/${
            data.data.listing.s3Prefix
          }/${
            data.data.listing.images.find((image) => image.main === true)
              .fileName
          }`;
          arr.push(url);
          await this.setState({ imageUrl: url });
        }
        this.setState({ images: arr });
      }
      return data;
    });
  }

  async handleClick() {
    message.warning(
      'This feature has been frozen by the Developer, Contact the Development Department'
    );
    return;
    /*
            senduser params

            reserver_id = id for recieving user *required
            data_senderId = id for sending user ^ * required when notification is a user profile // if sender is an admin send "ADMIN" as ID
            data_adId = main id for either listing or a user profile
            headings = main title for the push notification *required when missing take content
            url = https//khareta.com/properties/"add.url" // website url 
            big_picture = main image of listing for push notification // outside app
            data_url = /viewAd/"listing id" // app url
            data_sub_message_in_app = example "click here" * required
            contents = notification main message *required
            data_notification_type = “NEW_AD”,
                                      “REJECT_AD”,
                                      “APROVED_AD”,
                                      “REACHED_100_AD”,
                                      “REACHED_1000_AD”, * required
            data_in_app_img = display the main img in app notification panel * required if missing take big_picture in its place too.
            */
    const Message = this.state.inputValue;
    const header = this.state.headingsValue;
    const subMessage = this.state.SubMessageValue;
    const dataID = this.state.dataIdValue;
    // const author = this.props.author;
    const dataUrl = this.state.dataUrlValue;
    // const input_url = this.state.inputUrl;

    const data_adId = dataID; //input;
    const headings = header;

    const data_url = dataUrl; //
    const url = this.state.url;

    const type = this.state.type;
    const big_picture = this.state.imageUrl;
    const fillDataId =
      type === 'NEW_AD'
        ? `/viewAd/${data_adId}`
        : type === 'USER_PAGE'
        ? `/user_page/profile_preview/${data_adId}`
        : data_url;

    const data_sub_message_in_app = subMessage;
    const contents = Message;
    const data_notification_type = type;
    const data_in_app_img = big_picture;
    const insideAppLink = `${
      data_adId.length > 3 ? `&data_adId=${data_adId}` : ``
    }`;
    const recID = this.state.recieverIdValue;
    const reserver_id = recID;
    const data_senderId = 'ADMIN';
    const check =
      data_sub_message_in_app.length > 3 &&
      contents.length > 3 &&
      headings.length > 3;
    const check2 =
      this.state.type === 'NEW_AD' || this.state.type === 'USER_PAGE'
        ? data_adId.length > 8
        : true;
    if (check === true && check2 === true) {
      fetch(
        `${
          `${process.env.REACT_APP_CLOUD_FUNCTIONS_BASE_URL}/senduser?resever_id=${reserver_id}&data_senderId=${data_senderId}` +
          insideAppLink +
          `&headings=${headings}` +
          `&url=${url}` +
          `&big_picture=${big_picture}` +
          `${data_url.length > 3 ? `&data_url=${fillDataId}` : ``}` +
          `&data_sub_message_in_app=${data_sub_message_in_app}&contents=${contents}&data_notification_type=${data_notification_type}&data_in_app_img=${data_in_app_img}`
        }`
      ).then((res) => console.log(res));
      message.success('Success');
    } else {
      message.error(
        `Make sure required fields are filled :${
          check2 === false ? ' Data ID ,' : ''
        } ${check === false ? ' red stared fields' : ''} `
      );
    }
  }
  async handleTestClick() {
    const userIds = this.state.testUsers;
    for (let i = 0; i < userIds.length; i++) {
      await this.setState({ recieverIdValue: userIds[i] });
      await this.handleClick();
    }
  }
  async handleTestUserSend() {
    const userIds = this.state.testUser.id;
    await this.setState({ recieverIdValue: userIds });
    await this.handleClick();
  }
  handleRecieverID(v) {
    this.setState({ recieverIdValue: v.target.value });
  }
  showModal = () => {
    this.setState({
      visible: true,
    });
  };
  handleClicks = (v) => {
    const current = v.key;
    this.setState({ type: current });
  };
  handleLinks = (v) => {
    const current = v.key;
    this.setState({ dataUrlValue: current });
  };
  handleImage(v) {
    this.setState({ imageUrl: v });
  }
  handleImageChoice() {
    const Images = this.state.images;
    Images.push(this.state.imageValue);
    this.setState({ images: Images });
  }
  handleDataUrlChoice() {
    const links = this.state.pushlinks;
    links.push(this.state.dataUrlValue);
    this.setState({ pushlinks: links });
  }
  handleUserField(v) {
    this.setState({ testUserField: v.target.value });
  }
  handleTestUser(v) {
    this.setState({ testUser: v });
  }
  async handleUserChoice() {
    const users = this.state.testUsers;
    const found = this.simpleSearch(this.state.testUserField, users);
    if (found !== true) {
      users.push(this.state.testUserField);
    }
    await this.setState({ testUsers: users });
    this.queryUsers(this.state.testUsers[this.state.testUsers.length - 1]); //////
  }
  handleImageField(v) {
    this.setState({ imageValue: v.target.value });
  }

  handleTypeChoice() {
    const types = this.state.types;
    types.push(this.state.typeField);
    this.setState({ types: types });
  }

  handleTypeField(v) {
    this.setState({ typeField: v.target.value });
  }
  handleTopicField(v) {
    this.setState({ topicField: v.target.value });
  }
  handleUrl(v) {
    this.setState({ Url: v.target.value });
  }
  search(nameKey, myArray) {
    for (var i = 0; i < myArray.length; i++) {
      if (myArray[i].data.users[0].id === nameKey) {
        return true;
      }
    }
  }
  simpleSearch(nameKey, myArray) {
    for (var i = 0; i < myArray.length; i++) {
      if (myArray[i] === nameKey) {
        return true;
      }
    }
  }
  queryUsers(v) {
    API.graphql(
      graphqlOperation(Admin.User.GET_USERS_NAMES, {
        where: {
          id: { equals: v },
        },
      })
    ).then((data) => {
      if (data.data.users.length > 0) {
        const UsersArr = this.state.testUserValues;
        const found = this.search(data.data.users[0].id, UsersArr);
        if (found !== true) {
          UsersArr.push(data);
        }
        this.setState({ testUserValues: UsersArr });
      }
      return data;
    });
  }

  async handleUserNames() {
    const arr = this.state.testUsers;
    for (let i = 0; i < arr.length; i++) {
      this.queryUsers(arr[i]);
    }
  }
  render() {
    const TypeMenu = (props) => {
      return (
        <Menu onClick={this.handleClicks.bind(this)}>
          {this.state.types.map((type) => (
            <Menu.Item {...props} key={type} value={type}>
              {type}
            </Menu.Item>
          ))}
        </Menu>
      );
    };

    const PushMenu = (props) => {
      return (
        <Menu onClick={this.handleLinks.bind(this)}>
          {this.state.pushlinks.map((link) => (
            <Menu.Item {...props} key={link} value={link}>
              {link}
            </Menu.Item>
          ))}
        </Menu>
      );
    };
    const pushmenu = <PushMenu />;
    const menu = <TypeMenu />;
    const layout = {
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
    };

    return (
      <div>
        {/* <Button type="primary" onClick={this.showModal}>
          Custom Message
        </Button> */}
        <Modal
          width={700}
          title="Basic Modal"
          onCancel={this.handleCancel}
          visible={this.state.visible}
          footer={[
            <Button key="back" onClick={this.handleCancel}>
              عودة
            </Button>,
          ]}
        >
          <Col>
            <h3 style={{ color: 'green', textAlign: 'center' }}>
              Send Custom Messages
            </h3>
            <Form {...layout} name="basic">
              {this.props.user === undefined && (
                <Form.Item
                  label="Reciever ID"
                  name="Reciever ID"
                  rules={[{ required: true, message: 'Reciever ID' }]}
                >
                  <Input onChange={this.handleRecieverID.bind(this)} />
                </Form.Item>
              )}
              <Form.Item
                label="Heading"
                name="Heading"
                rules={[{ required: true, message: 'Heading' }]}
              >
                <Input onChange={this.handleHeadings.bind(this)} />
              </Form.Item>
              <Form.Item
                label="App Text"
                name="Sub Message"
                rules={[{ required: true, message: 'Sub Message' }]}
              >
                <Input.TextArea onChange={this.handleSubMessage.bind(this)} />
              </Form.Item>
              <Form.Item
                label="Push Text"
                name="Message"
                rules={[{ required: true, message: 'Message' }]}
              >
                <Input.TextArea
                  value={''}
                  onChange={this.handleMessage.bind(this)}
                />
              </Form.Item>

              <div>
                <Form.Item
                  style={{ textAlign: 'start' }}
                  label="Type"
                  name="Notification Type"
                  rules={[{ required: true }]}
                >
                  <Input
                    style={{
                      marginLeft: 20,
                      display: 'inline',
                      width: '30%',
                    }}
                    onChange={this.handleTypeField.bind(this)}
                  />
                  <div
                    style={{
                      marginLeft: 20,
                      display: 'inline',
                      width: '30%',
                    }}
                  >
                    <Button
                      style={{ display: 'inline' }}
                      onClick={this.handleTypeChoice.bind(this)}
                    >
                      Add type
                    </Button>
                  </div>
                  <div
                    style={{
                      marginLeft: 20,
                      display: 'inline',
                      width: '30%',
                    }}
                  >
                    <Dropdown overlay={menu} trigger={['click']}>
                      <Button onClick={(e) => e.preventDefault()}>
                        {this.state.type}
                        <DownOutlined />
                      </Button>
                    </Dropdown>
                  </div>
                </Form.Item>

                <Form.Item label="Url" name="Url" rules={[{ message: 'Url' }]}>
                  <Input
                    placeholder="http//khareta.com"
                    onChange={this.handleUrl.bind(this)}
                  />
                </Form.Item>
                {this.state.type !== 'OTHER' && (
                  <Form.Item
                    label="Data ID"
                    name="Data ID"
                    rules={[
                      {
                        required:
                          this.state.type === 'NEW_AD' ||
                          this.state.type === 'USER_PAGE'
                            ? true
                            : false,
                        message: 'Data ID',
                      },
                    ]}
                  >
                    <Input onChange={this.handleDataId.bind(this)} />
                  </Form.Item>
                )}
                {!(
                  this.state.type === 'NEW_AD' ||
                  this.state.type === 'USER_PAGE'
                ) && (
                  <div style={{ display: 'inline' }}>
                    <Form.Item
                      label="Push Link"
                      name="Data Url"
                      rules={[{ message: 'Data Url' }]}
                    >
                      <Input
                        placeholder={this.state.dataUrl}
                        style={{ display: 'inline', width: '40%' }}
                        value={this.state.dataUrlValue}
                        onChange={this.handleDataUrl.bind(this)}
                      />
                      <Button
                        style={{ display: 'inline' }}
                        onClick={this.handleDataUrlChoice.bind(this)}
                      >
                        Add Push Link
                      </Button>
                      <Dropdown overlay={pushmenu} trigger={['click']}>
                        <Button onClick={(e) => e.preventDefault()}>
                          {this.state.dataUrlValue}
                          <DownOutlined />
                        </Button>
                      </Dropdown>
                    </Form.Item>
                  </div>
                )}
                <div style={{ display: 'inline' }}>
                  <Form.Item
                    label="Add an Image"
                    name="Add an Image"
                    rules={[{ message: 'Add an Image' }]}
                  >
                    <Input
                      style={{ display: 'inline', width: '55%' }}
                      onChange={this.handleImageField.bind(this)}
                    />
                    <Button
                      style={{ display: 'inline' }}
                      onClick={this.handleImageChoice.bind(this)}
                    >
                      Add Image
                    </Button>
                    <Button
                      style={{ display: 'inline' }}
                      onClick={() => this.setState({ imageUrl: '' })}
                    >
                      Empty Image
                    </Button>
                  </Form.Item>
                </div>
              </div>
            </Form>

            <div style={{ textAlign: 'center' }}>
              {this.state.images.map((e) => (
                <img
                  style={
                    this.state.imageUrl === e
                      ? { border: '10px solid green', margin: 10 }
                      : { border: '10px solid grey', margin: 10, width: 100 }
                  }
                  key={e}
                  alt=""
                  width={100}
                  onClick={() => this.handleImage(e)}
                  src={e}
                />
              ))}
            </div>
            <div
              style={{
                textAlign: 'center',
              }}
            >
              <div style={{ marginBottom: 20 }}>
                <Button
                  type="primary"
                  disabled={this.state.active}
                  onClick={async (e) => {
                    await this.setState({
                      recieverIdValue: this.props.user,
                    });
                    this.handleClick(e);
                    await this.setState({ active: true });

                    setTimeout(() => {
                      this.setState({ active: false });
                    }, 3000);
                  }}
                >
                  Send
                </Button>
              </div>

              <div>
                <div style={{ textAlign: 'center' }}>
                  <h3>Test Users Block</h3>
                </div>

                <div>
                  <div style={{ display: 'inline' }}>
                    <Form {...layout} name="basic">
                      <Form.Item
                        label="Test User"
                        name="Test User"
                        rules={[{ message: 'Test User' }]}
                      >
                        <Input
                          style={{ display: 'inline', width: '60%' }}
                          onChange={this.handleUserField.bind(this)}
                        />
                        <Button
                          style={{ display: 'inline' }}
                          onClick={this.handleUserChoice.bind(this)}
                        >
                          Add a test user
                        </Button>
                      </Form.Item>
                    </Form>
                  </div>

                  <div style={{ display: 'flex' }}>
                    {this.state.testUserValues.map((user) =>
                      user.data.users.length > 0 ? (
                        <div
                          onClick={() =>
                            this.handleTestUser(user.data.users[0])
                          }
                          key={user.data.users[0].id}
                          style={{
                            flex: 1,
                            width: '18%',
                            border: '1px solid grey',
                            margin: 3,
                          }}
                        >
                          <h3>{user.data.users[0].name}</h3>
                        </div>
                      ) : (
                        <div
                          style={{
                            flex: 1,
                            width: '18%',
                            border: '1px solid grey',
                            margin: 3,
                          }}
                        >
                          `User Doesn't Exist`
                        </div>
                      )
                    )}
                  </div>
                  <br></br>
                  <div>Picked user : {this.state.testUser.name}</div>
                  <br></br>
                </div>
                <div>
                  <Button onClick={this.handleTestUserSend.bind(this)}>
                    Send to Picked Test User
                  </Button>
                  <Button
                    type="primary"
                    disabled={this.state.active1}
                    onClick={async (e) => {
                      this.handleTestClick(e);
                      await this.setState({ active1: true });

                      setTimeout(() => {
                        this.setState({ active1: false });
                      }, 3000);
                    }}
                  >
                    Send to test users
                  </Button>
                </div>
              </div>
            </div>
          </Col>
        </Modal>
      </div>
    );
  }
}
export default CustomNotification;
